/* ==========================================================================
   Gutsi - homepage creator wall: autoplay the videos.
   Loaded from snippets/stylesheets.liquid with defer.
   Styling companion: assets/claude-creator-wall.css (card size).

   WHY: Matt, 9 Sep 2026 - "it would be good for the videos to auto play and
   show their captions, really neat way of getting social proof quickly" -
   and Maddie agreed.

   The captions are BURNED INTO the picture, not text tracks (both files
   report zero textTracks), so there is nothing to switch on - playing the
   video IS showing the captions.

   THREE THINGS THAT MATTER HERE:

   1. Muted, or it will not autoplay at all. Every browser blocks autoplay
      with sound. The controls are deliberately left in place so anyone who
      wants the audio can unmute - which is the whole point of a creator
      testimonial.

   2. Only while on screen. These are 70s and 43s at 720p, two of them side by
      side, and the wall sits well down the homepage. Without the observer,
      every visitor would stream both files whether they ever scrolled to them
      or not. They pause the moment they leave the viewport.

   3. Looping, because they are long. A visitor arriving mid-scroll should not
      land on a frozen last frame.

   Reduced-motion visitors get the poster frame and no playback.
   ========================================================================== */

(function () {
  function setUp() {
    var videos = document.querySelectorAll('.gcw .gcw-media video');
    if (!videos.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    Array.prototype.forEach.call(videos, function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');

      function play() {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play();
            } else {
              try { video.pause(); } catch (e) {}
            }
          });
        }, { threshold: 0.35 }).observe(video);
      } else {
        play();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUp);
  } else {
    setUp();
  }
})();
